module.exports = __webpack_public_path__ + "img/Group 1-2.a0bd010a.png";